import { postCosmosApiData, getCosmosApiData, apiErrorOccurred } from 'js/helpers/apiData';
import store from 'js/store';
import { DOWNLOAD_MENU_UPDATE, DOWNLOAD_MENU_LOAD, DOWNLOAD_MENU_SUBMIT, DOWNLOAD_MENU_SUBMIT_END, constructDownloadMenuId } from '../reducers/nav/downloadMenu';
var DOWNLOAD_MENU_API_URL = 'download_menu';

function constructDownloadMenuApiUrl(countryCode, plotId) {
  return "/countries/".concat(countryCode, "/").concat(plotId, "/").concat(DOWNLOAD_MENU_API_URL);
}

export function updateDownloadMenuMetadata(countryCode, plotId, metadata) {
  return {
    type: DOWNLOAD_MENU_UPDATE,
    countryCode: countryCode,
    plotId: plotId,
    metadata: metadata
  };
}
export function downloadMenuMetadataLoad(countryCode, plotId) {
  return {
    type: DOWNLOAD_MENU_LOAD,
    countryCode: countryCode,
    plotId: plotId
  };
}
export function downloadMenuFeedbackSubmit(countryCode, plotId) {
  return {
    type: DOWNLOAD_MENU_SUBMIT,
    countryCode: countryCode,
    plotId: plotId
  };
}
export function downloadMenuFeedbackSubmitEnd(countryCode, plotId) {
  return {
    type: DOWNLOAD_MENU_SUBMIT_END,
    countryCode: countryCode,
    plotId: plotId
  };
}
export function fetchAndUpdateDownloadMenuMetadata(countryCode, plotId) {
  return function (dispatch) {
    if (store.getState().downloadMenu[constructDownloadMenuId(countryCode, plotId)]) return;
    dispatch(downloadMenuMetadataLoad(countryCode, plotId));
    return getCosmosApiData(constructDownloadMenuApiUrl(countryCode, plotId)).then(function (downloadMenuMetadata) {
      dispatch(updateDownloadMenuMetadata(countryCode, plotId, downloadMenuMetadata));
    }).catch(function (error) {
      // If there was an error fetching the data, invalidate the data
      if (apiErrorOccurred(error)) {
        dispatch(updateDownloadMenuMetadata(countryCode, plotId, null));
      } // TODO: throw error here still?


      throw error;
    });
  };
}
export function postFeedback(countryCode, plotId, postFormData) {
  return function (dispatch) {
    dispatch(downloadMenuFeedbackSubmit(countryCode, plotId));
    return postCosmosApiData(constructDownloadMenuApiUrl(countryCode, plotId), null, postFormData).then(function (feedbackResponse) {
      dispatch(downloadMenuFeedbackSubmitEnd(countryCode, plotId));
      return feedbackResponse;
    }).catch(function (error) {
      if (apiErrorOccurred(error)) {// TODO: move the code below up here?
      }

      dispatch(downloadMenuFeedbackSubmitEnd(countryCode, plotId)); // TODO: throw error here still?

      throw error;
    });
  };
}